<template>
  <div class="result-view" data-qe-id="results">
    <t-content main>
      <c-tournament-header :zone="zoneId" :language="$i18n.locale" />
      <c-navigation>
        <router-link v-if="zoneId" :to="{ path: `/tournaments/${zoneId}` }">{{
          $t('resultView.buttons.back')
        }}</router-link>
      </c-navigation>
      <t-container>
        <m-result :competition-id="competitionId" />
      </t-container>
    </t-content>
    <t-content>
      <t-container>
        <c-customer-service
          @customer="onCustomer"
          :text="$t('resultView.customerService.headline', { competitionId })"
        ></c-customer-service>
      </t-container>
    </t-content>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import MResult from '@/modules/MResult.vue'
import CCustomerService from '@/components/CCustomerService.vue'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import { getSubTopic, CsFormPreselections } from '@/lib/customerService'
import CNavigation from '@/components/CNavigation.vue'

const props = defineProps<{ competitionId: string }>()
const store = useStore()

const zoneId = computed(() => {
  return store.getters['results/zoneId']
})

function onCustomer() {
  events.$emit('cs-form', {
    topic: 'duelError',
    subTopic: getSubTopic(zoneId.value),
    competitionId: props.competitionId,
  } as CsFormPreselections)
}
</script>
